export default __webpack_public_path__ + "static/media/UsreIcon.80068358.png";